import { render } from "./PillLoader.vue?vue&type=template&id=0cbff207&scoped=true"
const script = {}

import "./PillLoader.vue?vue&type=style&index=0&id=0cbff207&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cbff207"]])

export default __exports__